<template>
  <div class="dashboard-loader">
    <md-progress-spinner
      class="md-success"
      :md-stroke="10"
      :md-diameter="50"
      md-mode="indeterminate"
    ></md-progress-spinner>
  </div>
</template>

<script>
export default {
  name: "DashboardLoader"
}
</script>
<style scoped>
.dashboard-loader {
  min-height: 400px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.74);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.md-progress-spinner.md-theme-default :deep(.md-progress-spinner-circle) {
  stroke: #ff6d00 !important;
}
</style>
